export default __webpack_public_path__ + "static/media/unstaking-step-three-alpha.07211afa.svg";